globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.AddBusinessActivity = (function(superClass) {

    utils.extend(AddBusinessActivity, superClass);

    function AddBusinessActivity() {
        return AddBusinessActivity.__super__.constructor.apply(this, arguments);
    }

    $.extend(AddBusinessActivity.prototype, {
        init: function() {
            var modal = this;

            appCustomerSpace.LimitlessPlugins.Tooltip.init(this.$html);

            var $modal        = $('.modal'),
                $searchInput  = $modal.find('.input-filter'),
                $formGroup    = $searchInput.closest('.form-group'),
                $mediaLink    = $modal.find('.media-link'),
                context       = $modal.data('context');

            $searchInput.on('input', utils.delay(function() {
                var request  = $(this).val(),
                errorMsg = 'Erreur de chargement';

                $formGroup.find('i').removeClass('icon-search4').addClass('icon-spinner2 spinner');

                $.ajax({
                    type: "GET",
                    url: $(this).data('ajax-url'),
                    data: {request: request },
                    success: function(data)
                    {
                        if (data.response == 1) {
                            $modal.find('.media-list').html(data.html).end().find('.other-business-activity').show();
                            $modal.find('.search-activities-message').hide();
                        } else {
                            alert(errorMsg);
                        }

                        $formGroup.find('i').removeClass('icon-spinner2 spinner').addClass('icon-search4');

                        appCustomerSpace.LimitlessPlugins.Tooltip.init($modal);
                    }
                }).fail(function() {
                    alert(errorMsg);
                });
            }, 500));

            $modal.on('click', '.media-link', function(e)
            {
                e.preventDefault();

                var $container       = $(this),
                    selectedBusinessActivityId    = $container.data('business-activity-id'),
                    selectedBusinessActivityLabel = $container.find('.business-activity-label').text();

                appCustomerSpace.Loader().start({ $container: $container });

                if (context == "secondary_business_activity") {
                    var $secondaryBusinessActivitiesContainer = $('.secondary-business-activities-container'),
                        $formGroups = $secondaryBusinessActivitiesContainer.find('.form-group'),
                        $firstFormGroup = $formGroups.first(),
                        $firstDestroyInput = $firstFormGroup.find('.secondary-business-activity-destroy-input');

                    if ($firstFormGroup.find('input.business-activity-id-input').val() != "") {
                        var $newFormGroup = $formGroups.last().clone(),
                            label = $newFormGroup.data('label');

                        $newFormGroup.find('input.business-activity-id-input').val(selectedBusinessActivityId).end()
                                     .find('input.business-activity-label-input').val(selectedBusinessActivityLabel).end()
                                     .find('.secondary-business-activity-destroy-input').val(false).end()
                                     .appendTo($secondaryBusinessActivitiesContainer).end().show();

                        // Rewrite input index
                        var index     = new Date($.now()).getTime();
                        $newFormGroup.find('input').each(function(){
                            var $input    = $(this);
                            var inputName = $input.attr('name');

                            if(inputName != undefined) {
                                var newName   = inputName.replace(/(\[\d{10}\])/, '[' + index + ']');
                                $input.attr('name', newName);
                            }
                        })
                    } else {
                        $secondaryBusinessActivitiesContainer.find('p').hide();
                        $firstFormGroup.parent().show().end()
                                       .find('input.business-activity-id-input').val(selectedBusinessActivityId).end()
                                       .find('input.business-activity-label-input').val(selectedBusinessActivityLabel);
                        $firstDestroyInput.val(false);
                    }
                } else if (context == "main_business_activity") {
                    $('.main_business_activity_input').val(selectedBusinessActivityLabel);
                    $('.store-main-business-activity-id').val(selectedBusinessActivityId);
                }
                modal.close();
                appCustomerSpace.Loader().stop({ $container: $container });
            });

            return AddBusinessActivity.__super__.init.apply(this, arguments);
        }
    });

    return AddBusinessActivity;

})(appCustomerSpace.Modal);
